import {
  AccountBalanceWalletOutlined,
  DescriptionOutlined,
  LibraryBooksOutlined,
  ManageAccountsOutlined,
  PaymentsOutlined
} from '@mui/icons-material';

const pagesSection = [
  {
    href: '/dashboard/journal-entries',
    icon: LibraryBooksOutlined,
    title: 'Journal Entries',
    children: [
      {
        href: './journal-entries/cash-transaction',
        title: 'Submit Cash Transaction',
        authKeys: ['CashTransactionRE']
      },
      {
        href: './journal-entries/transfer-between-accounts',
        title: 'Transfer Between Accounts',
        authKeys: ['TransferBetweenAccountsRE']
      },
      {
        href: './journal-entries/trade-currency/buy',
        title: 'Trade Currency',
        authKeys: ['TradeCurrencyRE']
      },
      {
        href: './journal-entries/increase-customer-credit',
        title: 'Increase Customer Credit',
        authKeys: ['IncreaseCustomerCredit']
      },
      {
        href: './journal-entries/decrease-customer-credit',
        title: 'Decrease Customer Credit',
        authKeys: ['DecreaseCustomerCredit']
      }
    ]
  },
  {
    href: '/dashboard/bank-transactions',
    icon: LibraryBooksOutlined,
    title: 'BankTransaction',
    children: [
      {
        href: './journal-entries/interbank-transaction',
        title: 'Interbank Transaction',
        authKeys: ['InterbankTransactionRE']
      },
      {
        href: './journal-entries/bank-transaction',
        title: 'Submit Bank Transaction',
        authKeys: ['BankTransactionRE']
      },
      {
        href: './journal-entries/unknown-bank-transactions-list',
        title: 'Unknown Bank Transactions',
        authKeys: ['UnknownBankTransactionsA']
      },
      {
        href: './journal-entries/bank-transactions-list',
        title: 'Bank Transactions',
        authKeys: ['UnknownBankTransactionsA']
      }
    ]
  },
  {
    href: '/dashboard/accounts',
    icon: AccountBalanceWalletOutlined,
    title: 'Accounts',
    children: [
      {
        href: './customer-credit-account',
        title: 'Credits Account',
        authKeys: ['SupportCreditCustomer']
      },
      {
        href: './system-account/list',
        title: 'System Accounts',
        authKeys: ['SystemAccountsList']
      },
      {
        href: './customer/list',
        title: 'Customers List',
        authKeys: ['CustomersListA']
      },
      {
        href: './organization/list/organizations-list',
        title: 'Organizations List',
        authKeys: ['OrganizationListA']
      },
      {
        href: './accounts/banks-list',
        title: 'Banks List',
        authKeys: ['BankAccountsList']
      },
      {
        href: './global-ledger/branch/list',
        title: 'Branches List',
        authKeys: ['BranchesListA']
      },
      {
        href: './global-ledger/receiver/receivers-list',
        title: 'Receivers List',
        authKeys: ['ReceiversListA']
      },
      {
        href: './archivedcustomer/list',
        title: 'Archived Accounts',
        authKeys: ['ArchivedAccountsA']
      }
    ]
  },
  {
    href: '/dashboard/draft',
    icon: PaymentsOutlined,
    title: 'Drafts',
    children: [
      {
        href: './draft/submission/outgoing',
        title: 'Draft Submission',
        authKeys: ['DraftRE']
      },
      {
        href: './draft/orders/list',
        title: 'Draft List',
        authKeys: ['DraftDocumentsListA']
      }
    ],
    authKeys: ['DraftRE']
  },
  {
    href: '/dashboard/reports',
    icon: DescriptionOutlined,
    title: 'Reports',
    children: [
      {
        href: './reports/pending-transactions-list',
        title: 'Pending Transactions List',
        authKeys: ['PendingDraftsList']
      },
      {
        href: './reports/profit-and-loss-statement',
        title: 'Profit And Loss Statement',
        authKeys: ['ProfitAndLossStatement']
      },
      {
        href: './reports/payment-order',
        title: 'Payment Order',
        authKeys: ['PaymentOrderA']
      },
      {
        href: './reports/debtor-and-creditor-list',
        title: 'Debtor And Creditor List',
        authKeys: ['DebtorCreditorA']
      },
      {
        href: './reports/cheques-list',
        title: 'Cheques List',
        authKeys: ['ChequesListA']
      },
      {
        href: './reports/commissions-report',
        title: 'Commissions Report',
        authKeys: ['CommissionReportsA']
      },
      {
        href: './reports/trade-currencies-list',
        title: 'Trade Currencies List',
        authKeys: ['TradeCurrencyA']
      },
      {
        href: './reports/excel-data-output',
        title: 'Excel Data Output',
        authKeys: ['ExcelPI']
      },
      {
        href: './reports/financial-operation',
        title: 'Financial Operation',
        authKeys: ['FinancialOperationsA']
      },
      {
        href: './reports/operation-of-the-day',
        title: 'Operation of the day',
        authKeys: ['DayOperation']
      },
      {
        href: './reports/notes',
        title: 'Notes',
        authKeys: ['notesA']
      }
    ]
  },
  {
    href: '/dashboard/system-management',
    icon: ManageAccountsOutlined,
    title: 'System Management',
    children: [
      {
        href: './system-management/system-settings/update',
        title: 'System Settings',
        authKeys: ['SystemSettingItemA']
      },
      {
        href: './system-management/operation-of-the-day',
        title: 'Operation of the day',
        authKeys: ['DayOperation']
      },
      {
        href: './journal-entries/currency-management',
        title: 'Currencies Management',
        authKeys: ['CurrencyManagementList']
      }
      // {
      //   href: './report/reported-bugs',
      //   title: 'Reported Bugs'
      // }
      // {
      //   href: '/dashboard/system-guides',
      //   title: 'System Guides'
      // }
    ]
  }
];

const navItems = [
  {
    title: 'Pages',
    pages: pagesSection
  }
];

export default navItems;
